import { useGetProcesses } from 'gcs-common/clients/api/entities/processes/processes-api';
import LoadingIndicator from 'gcs-common/components/LoadingIndicator/LoadingIndicator';
import { getChannelOPUserId, getPrimaryHouseForChannel } from 'gcs-common/slices/channel/channelSelectors';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getFilter } from 'gcs-common/slices/processes/processesSelectors';
import InfiniteScroll from 'react-infinite-scroller';
import { useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';
import Process from '../Process/Process';
import styles from './styles.module.scss';

const ProcessList = () => {
  const selectedChannelId: string = useSelector(getSelectedChannelId);
  const channelOpUserId: string = useSelector(getChannelOPUserId(selectedChannelId));
  const filter = useSelector(getFilter);
  const { name: queryString, type: queryType } = filter || {};
  const isAgent: boolean = useSelector(getIsAgent);
  const houseId: string = useSelector(getPrimaryHouseForChannel(selectedChannelId));

  const { data, hasNextPage, fetchNextPage, isFetching } = useGetProcesses({
    query: {
      query_type: queryType,
      query_string: queryString,
      user_id: isAgent ? channelOpUserId : undefined,
      house_id: houseId,
    },
  });

  const [loadNextProcessPage] = useDebouncedCallback(() => {
    fetchNextPage()
      .then(() => {})
      .catch(() => {});
  }, 500);

  if (isFetching && (!data || data.length === 0)) {
    return <LoadingIndicator key="loading-indicator" />;
  }

  if (!isFetching && (!data || data.length === 0)) {
    return <div className={styles.errorMessage}>Keine Vorgänge gefunden.</div>;
  }

  return (
    <div className={styles.processList} data-testid="process-list">
      <InfiniteScroll
        pageStart={1}
        loadMore={loadNextProcessPage}
        hasMore={hasNextPage}
        useWindow={false}
        initialLoad={false}
        threshold={100}
      >
        {data?.map((process, index) => {
          // use SortDate by default, but fall back to CreationDate if SortDate not available
          let previousDate: string | undefined;
          const previouseProcess = data[index - 1];
          if (previouseProcess) {
            previousDate = previouseProcess.SortDate || previouseProcess.CreationDate;
          }
          return (
            <Process
              key={`${process.ProcessNumber}-${process.ProcessSuffix}-${index}`}
              process={process}
              previousProcessSortDate={previousDate}
            />
          );
        })}
        {isFetching && <LoadingIndicator key="loading-indicator" />}
      </InfiniteScroll>
    </div>
  );
};

export default ProcessList;
